import axios from "axios"
import { InformacionFamiliarData } from "components/InformacionFamiliar";
import { UserData } from "components/Sidebar/Sidebar_Principal"
import { FilesUpload, ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import configData from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service"
import { NuevaInformacionSustitutoFamiliar, RespuestaSustituto } from "./TypesSustitutoFamiliar";
// import { InformacionTablaSustitutoFamiliar, NuevaInformacionSustitutoFamiliar, RespuestaSustituto } from "./TypesSustitutoFamiliar";



function parseEstadoCertificado(estado:string){
	switch (estado) {
		case "ACEPTADA":
			return "VALIDADO POR TALENTO HUMANO"			
		case "RECHAZADA":
			return "RECHAZADO POR TALENTO HUMANO"
		default:
			return estado
			
	}
}

export async function ObtenerFamiliaresConDiscapacidad() {
    var resultado:ResponseRequestGeneric<RespuestaSustituto> = {
		status:-1,
		
	}
	try {
		
		const datosusuario:UserData = authenticationService.currentUserValue;
		// const URL = configData.SERVER_URL + "InformacionFamiliar/InformacionFamiliarByIdPersonaDesc/" + datosusuario.idpersona
		const URL = configData.SERVER_URL + "InformacionFamiliar/InformacionFamiliarSustituto"
		
		const respuesta = await axios.get(URL,
			{
				headers: {...authHeaderWithUserData(datosusuario),
				
				}
			})
		
		// const valores:InformacionFamiliarData[]=  respuesta.data.entTabla;

		const valores:RespuestaSustituto=  respuesta.data;
		
		
		const mapearHistorial = valores.historialSustituto.map((val,ind) => {
			return {...val,acciones:val,estado:parseEstadoCertificado(val.estado)}
		})
		
		
		var valorMapeado = {...valores}
		valorMapeado.historialSustituto = mapearHistorial;

		resultado = {
			status:respuesta.status,
			dataResponse:valorMapeado,


		}

    } catch (error) {
		const errormessage = "Error al obtener información de familiares";
		alertService.error(errormessage)
		resultado = {
			status:500,
			errorMessage:errormessage
		}
    }

	return resultado;
}

export async function AgregarInformacionSustitutoFamiliar(informacion:NuevaInformacionSustitutoFamiliar,certificado:FilesUpload, idPersonaDependiente:number){
	
	var resultado:ResponseRequest = {
		status:200,		
	}
	try {
		const datosUsuario = authenticationService.currentUserValue;
		var formulario = new FormData();

		const fileEnviar:any = certificado.uploadFile;

		const informacionFamiliar:NuevaInformacionSustitutoFamiliar = {...informacion,idPersonaDependiente}


		const info = JSON.stringify(informacionFamiliar);
		formulario.append("certificado", fileEnviar, fileEnviar.name);
		formulario.append("informacionFamiliar", info)

		const URL = configData.SERVER_URL + "InformacionFamiliar/InformacionFamiliarSustituto"
		const respuesta = await axios.post(URL,formulario,{
			headers:{
				...authHeaderWithToken(datosUsuario.token),
				'Content-Type': 'multipart/form-data'
			}
		})

		resultado = {
			status : respuesta.status
		}


	} catch (error) {
		resultado = {
			status:-1,
			errorMessage:"Ha ocurrido un inconveniente. Intente más tarde"
		}

		if(axios.isAxiosError(error) && error.response){
			resultado = {
				status: error.response.status,
				errorMessage:error.response.data
			}				
		}


	}
	return resultado;
}


export async function ActualizarInformacionSustitutoFamiliar(informacion:NuevaInformacionSustitutoFamiliar,idPersonaDependiente:number,certificado?:FilesUpload|null){
	
	var resultado:ResponseRequest = {
		status:200,		
	}
	try {
		const datosUsuario = authenticationService.currentUserValue;
		var formulario = new FormData();

		if(certificado  !== undefined && certificado !== null){
			const fileEnviar:any = certificado.uploadFile;
			formulario.append("certificado", fileEnviar, fileEnviar.name);
		}
		
		const informacionFamiliar:NuevaInformacionSustitutoFamiliar = {...informacion,idPersonaDependiente}


		const info = JSON.stringify(informacionFamiliar);
		
		formulario.append("informacionFamiliar", info)

		const URL = configData.SERVER_URL + "InformacionFamiliar/InformacionFamiliarSustituto"
		const respuesta = await axios.put(URL,formulario,{
			headers:{
				...authHeaderWithToken(datosUsuario.token),
				'Content-Type': 'multipart/form-data'
			}
		})
		resultado = {
			status : respuesta.status
		}


	} catch (error) {
		resultado = {
			status:-1,
			errorMessage:"Ha ocurrido un inconveniente. Intente más tarde"
		}

		if(axios.isAxiosError(error) && error.response){
			resultado = {
				status: error.response.status,
				errorMessage:error.response.data
			}				
		}


	}
	return resultado;
}


export async function FinalizacionAnticipada(id:number,nombre:string) {
	var resultado:ResponseRequest = {
		status:-1
	}

	try {
		

		var formulario = new FormData()
		formulario.append("nombreTabla",nombre)
		formulario.append("idAsociado",id.toString())

		const datosUsuario:UserData = authenticationService.currentUserValue;



		const URL = configData.SERVER_URL + "InformacionFamiliar/InformacionFamiliarSustituto/FinalizarAnticipadamente"
		const respuesta = await axios.put(URL,formulario,{
			headers:{
				...authHeaderWithToken(datosUsuario.token),
				'Content-Type': 'multipart/form-data'
			}
		})
		resultado = {
			status : respuesta.status
		}
	} catch (error) {
		
		const errorMessage = axios.isAxiosError(error) && error.response ? error.response.data : "Ha ocurrido un inconveniente al tratar de finalizar anticipadamente";
		
		resultado = {
			status:-1,
			errorMessage:errorMessage
		}
	}

	return resultado;
}